import { Button, Flex } from 'antd';
import type { ButtonProps } from 'antd';
import styled from 'styled-components';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { FlexGap8 } from 'src/components/CommonStyledComponents/CommonStyledComponents.styled';
import ChangePassword from '@/assets/icons/ChangePassword.svg';
export const Wrapper = styled.div`
  position: relative;
`;

export const ChangePasswordButton = styled(Button).attrs(
  (): Pick<ButtonProps, 'type' | 'icon'> => ({
    type: 'text',
    icon: <ChangePassword />,
  }),
)`
  path {
    fill: ${({ theme }) => theme.colorPrimary};
  }
`;

export const EditButton = styled(Button).attrs(
  (): Pick<ButtonProps, 'type' | 'icon'> => ({
    type: 'text',
    icon: <EditOutlined />,
  }),
)``;

export const DeleteMobileButton = styled(Button).attrs(
  (): Pick<ButtonProps, 'icon' | 'danger' | 'style'> => ({
    icon: <DeleteOutlined />,
    danger: true,
    style: { background: 'transparent' },
  }),
)``;

export const RowActionsWrapper = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
})`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 999;
`;

export const MobileRow = styled(Flex)`
  overflow-x: auto;
  scrollbar-width: none;

  &.active:has(+ .gradient-overlay) + .gradient-overlay {
    display: none;
  }
`;

export const RowActions = styled(FlexGap8).attrs({
  justify: 'flex-end',
  align: 'center',
})`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 228px;
  justify-content: flex-end;
  .ant-btn {
    width: 38px;
    height: 38px;
  }
  .ant-btn-text {
    width: 38px;
    height: 38px;
    color: ${({ theme }) => theme.colorPrimary};
    border-color: ${({ theme }) => theme.colorPrimary};
  }
  .ant-icon {
    font-size: 24px;
  }
  background: ${({ theme }) =>
    `linear-gradient(270deg, ${theme.controlItemBgActive} 60%, rgba(230, 245, 241, 0.00) 82.87%)`};
`;

export const MobileEmail = styled(Flex)`
  color: ${({ theme }) => theme.colorTextDescription};
`;
